import React from "react";
import l from "components/util/l";

const CommentForm = ({
  isNew = false,
  isEditable = true,
  isSaveDisabled = false,
  text = "",
  style = {},
  className = "annotation-editor position-absolute bg-white border shadow px-3 py-2",
  children,
  onMouseDown,
  onChangeText,
  onRemove,
  onClose,
  onSave,
}) => {
  return (
    <div
      className={className}
      style={style}
      onMouseDown={onMouseDown}
    >

      <div className="d-flex justify-content-between mb-2">
        <b className="text-muted">
          {isNew
            ? l("Nuevo comentario%PA502")
            : l("Comentario%PA439")}
        </b>

        {!isNew && isEditable && !!onRemove && (
          <button
            className="btn btn-link btn-sm text-danger p-0"
            onClick={onRemove}
          >
            <i className="fas fa-trash" />
          </button>
        )}
      </div>

      {children}

      {!isEditable ? (
        <div className="p-2 mb-2 bg-light rounded" style={{ fontSize: "0.9rem", textAlign: "left" }}>
          {text}
        </div>
      ) : (
        <textarea
          className="form-control mb-2"
          rows="4"
          autoFocus
          value={text}
          onChange={(e) => onChangeText?.(e.target.value)}
        />
      )}

      <div className="d-flex justify-content-end align-items-center">
        <button
          className="btn btn-link btn-sm mr-2"
          onClick={onClose}
        >
          {isEditable ? l("Cancelar%GA021") : l("Cerrar%GA089")}
        </button>

        {isEditable && (
          <button
            className="btn btn-primary btn-sm"
            disabled={isSaveDisabled}
            onClick={onSave}
          >
            {l("Guardar%GA023")}
          </button>
        )}
      </div>

    </div>
  );
};

export default CommentForm;